import i18n from '../i18n'; 

export function filterLanguage(arr){
    return arr.filter((l)=>(l.locale === i18n.language))
} 
export function filterProperties(arr,lang){
    return arr.filter((l)=>(l.locale === lang))
} 